module.exports = __webpack_public_path__ + "img/register-light.4a020772.svg";